 
 
 
 
import * as queryString from 'query-string';
import type * as H from 'history';

import {
  FILTER_QUERIES,
  MyClothesSortTypes,
} from '@constants';

// TODO(o.kravchuk): remove these getters, replace them with useFilterData hook

export type PriceQuery = {
  priceFrom?: number | null;
  priceTo?: number | null;
  priceId?: [number] | null;
};

export type FiltersType = {
  sizes: number[];
  condition: number[];
  colors: number[];
  brands: number[];
  price: PriceQuery;
  catalogSlug?: string | null;
  orderBy: MyClothesSortTypes;
  searchText?: string | null;
};

export const getCatalogSlug = (search: H.Search) => {
  const searchParams = queryString.parse(search);
  return searchParams[FILTER_QUERIES.CATALOG] || '';
};

export const getProductSorting = (search: H.Search): MyClothesSortTypes => {
  const searchParams = queryString.parse(search);
  return searchParams[FILTER_QUERIES.SORT] || MyClothesSortTypes.BY_POPULAR;
};

export const getProductSizes = (search: H.Search): string[] | null => {
  const searchParams = queryString.parse(search);

  if (searchParams && searchParams.sizes) {
    if (Array.isArray(searchParams.sizes)) {
      return searchParams.sizes;
    }

    return [searchParams.sizes];
  }

  return [];
};

export const getProductConditions = (search: H.Search): string[] | null => {
  const searchParams = queryString.parse(search);

  if (searchParams && searchParams.conditions) {
    if (Array.isArray(searchParams.conditions)) {
      return searchParams.conditions;
    }

    return [searchParams.conditions];
  }

  return [];
};

export const getProductColor = (search: H.Search): string[] | null => {
  const searchParams = queryString.parse(search);

  if (searchParams && searchParams.colors) {
    if (Array.isArray(searchParams.colors)) {
      return searchParams.colors;
    }

    return [searchParams.colors];
  }

  return null;
};

export const getProductBrands = (search: H.Search): string[] | null => {
  const searchParams = queryString.parse(search);

  if (searchParams && searchParams.brands) {
    if (Array.isArray(searchParams.brands)) {
      return searchParams.brands;
    }

    return [searchParams.brands];
  }

  return null;
};

export const getProductPrice = (search: H.Search): PriceQuery => {
  const searchParams = queryString.parse(search);
  if (
    searchParams
    && (searchParams.priceFrom || searchParams.priceTo || searchParams.prices)
  ) {
    return {
      priceFrom: searchParams.priceFrom || parseInt(searchParams.priceFrom, 10),
      priceTo: searchParams.priceTo || parseInt(searchParams.priceTo, 10),
      priceId: searchParams.prices || [parseInt(searchParams.prices, 10)],
    };
  }

  return {
    priceFrom: null,
    priceTo: null,
    priceId: null,
  };
};

export const getSearchText = (search: H.Search): string | null | undefined => {
  const searchParams = queryString.parse(search);
  return searchParams.search_text;
};

export const removeSearchTextFilter = (search: H.Search, history: H.History) => {
  const searchParams = queryString.parse(search);

  history.push({
    pathname: history.location.pathname,
    search: queryString.stringify({
      ...searchParams,
      search_text: undefined,
    }),
  });
};

export const getFilterData = (search: H.Search): FiltersType => {
  const price = getProductPrice(search);
  const catalogSlug = getCatalogSlug(search);

  return {
    price,
    sizes: getProductSizes(search)
      ?.map((numStr: string) => parseInt(numStr, 10)) || [],
    brands: getProductBrands(search)
      ?.map((numStr: string) => parseInt(numStr, 10)) || [],
    condition: getProductConditions(search)
      ?.map((numStr: string) => parseInt(numStr, 10)) || [],
    colors: getProductColor(search)
      ?.map((numStr: string) => parseInt(numStr, 10)) || [],
    ...(catalogSlug ? { catalogSlug } : {}),
    orderBy: getProductSorting(search),
    searchText: getSearchText(search),
  };
};
